// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iVxqf","chat":"styles_chat__21v23","questions":"styles_questions__Flyue","checkout":"styles_checkout__oBxDV","timer":"styles_timer__9+oC+"};